module.exports = __webpack_public_path__ + "img/bi.08b719cf.png";